import Icon from '../components/Icon.vue'

Icon.register({
  'kiss-beam': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM209 227.9c4.2 7.5 15.6 4 15.1-4.5-3.3-42.1-32.2-71.4-56-71.4-23.8 0-52.7 29.3-56 71.4-0.7 8.5 10.7 11.9 14.9 4.5l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6zM304 396c0-13-13.4-27.3-35.2-36.4 21.8-8.7 35.2-23 35.2-36 0-19.2-28.7-41.5-71.5-44-8.4-1.1-12.2 11.8-3.6 15.4l17 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.8 21.5l-17 7.2c-6.1 2.6-6 12.3 0 14.8l17 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.8 21.5l-17 7.2c-8.5 3.6-4.9 16.2 3.6 15.4 42.8-2.5 71.5-24.8 71.5-44zM369 227.9c4.2 7.5 15.6 4 15.1-4.5-3.3-42.1-32.2-71.4-56-71.4-23.8 0-52.7 29.3-56 71.4-0.7 8.5 10.8 11.8 14.9 4.5l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/kiss-beam.js
// module id = 1501
// module chunks = 0